
import React from 'react';
import { UseFormReturn } from "react-hook-form";
import { TerraceFormValues } from "./types";
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";

interface SubmitterNameFieldProps {
  form: UseFormReturn<TerraceFormValues>;
  disabled?: boolean;
}

const SubmitterNameField: React.FC<SubmitterNameFieldProps> = ({ form, disabled = false }) => {
  return (
    <FormField
      control={form.control}
      name="submitterName"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Your Name</FormLabel>
          <FormControl>
            <Input 
              placeholder="Enter your name (optional)" 
              {...field} 
              disabled={disabled}
              className={disabled ? "bg-muted text-muted-foreground" : ""}
            />
          </FormControl>
          <FormDescription>
            {disabled ? "Available after filling the Google Maps link" : "Optional - so we can credit you for the submission"}
          </FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default SubmitterNameField;
